export const locale = {
  lang: 'en',
  data: {
    ERROR: {
      HTTP: {
        500: {
          'TITLE': 'Internal Server Error',
          'MESSAGE': 'Internal Server ERROR'
        },
      },
    },
  },
};
